import { deleteFaces } from './deleteFaces';

export const deleteFacesHandler = (faceIds: string[]) => (e?: React.MouseEvent<HTMLElement>): void => {
  e?.stopPropagation();
  deleteFaces({ faceIds });
};
